import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
/*
 * Service to keep track of the current routing state
 * IT IS NOT GUARANTEED TO HAVE THE LATEST ROUTER STATE
 * It is set up to contain the state of any navigationLink (see navigationLinkDirective onClick).
 * As a developer, you are responsible for calling setRoutingState manually before navigating using router.navigate
 * if you want to make use of this service
 * Can be used when the routing state needs to be saved in a more persistent manner
 * E.g., user navigates to a url which causes a redirect, this redirect should also use the original state
 *
 * Note that you need to call setRoutingState manually before navigating
 * since any automatic ways only resolve after the navigation has completely finished
 * (which would not work in the case of redirects)
 */
export class RoutingStateService {
    private routingState: Record<string, any> = {};

    public setRoutingState(state: Record<string, any>): void {
        try {
            this.routingState = state ?? {};
        } catch (exception) {
            console.error('Error while setting routing state', exception);
            this.routingState = {};
        }
    }

    public getRoutingState(): Record<string, any> {
        return this.routingState;
    }
}
